import { render } from "./EpisodeLatest.vue?vue&type=template&id=664f6601"
import script from "./EpisodeLatest.vue?vue&type=script&lang=js"
export * from "./EpisodeLatest.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__